<div [loading]="list.loading">
	<div class="table-top-container" *ngIf="list.itemCount && list.list !== null">
		<div class="flex1" style="line-height:25px;flex-basis:0;">Zvoleno <b>{{getSelectedCount()}}</b> záznamů</div>
		<pagescounter [list]="list" (callbackRegister)="pageableList.pagescounterCallbackRegister($event)"></pagescounter>
		<div class="flex1"></div>
	</div>
	<ng-template #entityTable></ng-template>
	<itemscounter *ngIf="list.itemCount && list.list !== null" [list]="list" (callbackRegister)="pageableList.itemcounterCallbackRegister($event)" style="max-width: 100px;"></itemscounter>
	<pagination *ngIf="list.itemCount && list.list !== null" [shouldUpdateUrl]="false" (pageChanged)="pageChanged($event)" [list]="list" (callbackRegister)="pageableList.paginationCallbackRegister($event)"></pagination>
</div>